import './App.css';
import Navbar from './Components/Navbar/Navbar';
import { BrowserRouter,Routes,Route } from "react-router";
import Shop from './Pages/Shop';
import ShopCategory from './Pages/ShopCategory';
import Product from './Pages/Product';
import Cart from './Pages/Cart';
import LoginSignup from './Pages/LoginSignup';
import Footer from './Components/Footer/Footer';
import men_banner from './Components/Assets/banner_mens.png'
import women_banner from './Components/Assets/banner_women.png'
import kids_banner from './Components/Assets/banner_kids.png'
import ForgotPassword from './Pages/ForgotPassword';
import ResetPassword from './Pages/ResetPassword';
import ShippingInfo from './Pages/ShippingInfo';
import OrderSuccess from './Pages/OrderSuccess';
import Profile from './Pages/Profile';
import Kapcsolat from './Pages/Kapcsolat';

function App() {
  return (
    <div>
      <BrowserRouter>
      <Navbar></Navbar>
      <Routes>
        <Route path='/' element={<Shop></Shop>}></Route>

        <Route path='/mens' element={<ShopCategory banner={men_banner} category="men"/>}></Route>

        <Route path='/womens' element={<ShopCategory banner={women_banner} category="women"/>}></Route>

        <Route path='/kids' element={<ShopCategory banner={kids_banner} category="kid"/>}></Route>

        <Route path='/product' element={<Product></Product>}>
          <Route path=':productId' element={<Product></Product>}></Route>
        </Route>

        <Route path='/cart' element={<Cart></Cart>}></Route>

        <Route path='/login' element={<LoginSignup></LoginSignup>}></Route>

        <Route path='/forgot-password' element={<ForgotPassword />} />
        <Route path='/reset-password/:token' element={<ResetPassword />} />

        <Route path="/shipping" element={<ShippingInfo />} />
        <Route path="/order-success" element={<OrderSuccess />} />
        <Route path='/profile' element={<Profile></Profile>}></Route>

        <Route path="/category/:main/:sub" element={<ShopCategory />} />
        <Route path="/:main" element={<ShopCategory />} />
        <Route path='/kapcsolat' element={<Kapcsolat></Kapcsolat>}></Route>

      </Routes>
      <Footer></Footer>
      </BrowserRouter>
      
    </div>
  );
}

export default App;
